import React from 'react';

function SubscribedMatchLoader() {
    return (
        <div className="notified-matches-box pending">
            <div className="module-title-box">
                <div className="wave-animation" />
            </div>
            <div className="notified-matches-slider">
                <div className="wave-animation" />
            </div>
        </div>
    );
}

export default SubscribedMatchLoader;
